import basicTheme from './basic';

const darkTheme = {
  ...basicTheme,
  textPrimary: '#fff',
  textSecondary: '#8e05c2',
  muted: '#dbdbdb',
  background: '#191919',
  accent: '#8e05c2'
}

export default darkTheme;